var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconHome = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-home-3",
    d: "M25.308,11.3,22.4,8.393V.762A.762.762,0,0,0,21.636,0H18.373a.762.762,0,0,0-.762.762V3.606L14.707.7a2.4,2.4,0,0,0-3.394,0L.713,11.3a2.4,2.4,0,0,0,1.7,4.1,2.436,2.436,0,0,0,.4-.033V23.2a2.8,2.8,0,0,0,2.8,2.8h4.954a.762.762,0,0,0,.762-.762V19.473H14.7v5.765a.762.762,0,0,0,.762.762h4.954a2.8,2.8,0,0,0,2.8-2.8V15.367a2.429,2.429,0,0,0,.4.033h0a2.4,2.4,0,0,0,1.7-4.1ZM19.134,1.523h1.74V6.87l-1.74-1.74Zm1.278,22.953H16.22V18.711a.762.762,0,0,0-.762-.762h-4.9a.762.762,0,0,0-.762.762v5.765H5.608A1.279,1.279,0,0,1,4.33,23.2V14.474l8.68-8.68,8.68,8.68V23.2a1.279,1.279,0,0,1-1.278,1.278ZM24.231,13.62a.877.877,0,0,1-1.24,0h0L13.549,4.178a.762.762,0,0,0-1.077,0L3.03,13.62h0a.877.877,0,0,1-1.24-1.24l10.6-10.6a.877.877,0,0,1,1.24,0l4.2,4.2,6.4,6.4A.878.878,0,0,1,24.231,13.62Z",
    transform: "translate(-0.011)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconHome, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-home.f96acd69.svg";
export { ForwardRef as ReactComponent };